import errorManager from '@/rollbar.js';

const stopRegistration = (subActivityCheckboxesArray, actionElement, event) => {
  if (subActivityCheckboxesArray.length && subActivityCheckboxesArray.every((cb) => !cb.checked)) {
    alert('Selezionare almeno una sottoattività!');
    if (event.cancelable) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (actionElement.type === 'checkbox') {
      actionElement.checked = false;
    }
  }
};

const showAlert = (subActivityCheckboxesSelector, stopButtonSelector, executeCheckboxSelector, executeMultiactivityNoSubactivity) => {
  if (executeMultiactivityNoSubactivity) return;

  document.querySelectorAll(executeCheckboxSelector).forEach((executeCheckbox) => {
    const counter = executeCheckbox.dataset.id;
    const subActivityCheckboxes = document.querySelectorAll(`${subActivityCheckboxesSelector}.checkbox-${counter}`);
    const subActivityCheckboxesArray = Array.from(subActivityCheckboxes);

    executeCheckbox.addEventListener('change', (event) => {
      stopRegistration(subActivityCheckboxesArray, event.currentTarget, event);
    });
  });

  document.querySelectorAll(stopButtonSelector).forEach((stopButton) => {
    const counter = stopButton.dataset.id;
    const subActivityCheckboxes = document.querySelectorAll(`${subActivityCheckboxesSelector}.checkbox-${counter}`);
    const subActivityCheckboxesArray = Array.from(subActivityCheckboxes);

    stopButton.addEventListener('click', (event) => {
      stopRegistration(subActivityCheckboxesArray, event.currentTarget, event);
    });
  });
};

const init = (subActivityCheckboxesSelector, stopButtonSelector, executeCheckboxSelector, executeMultiactivityNoSubactivity) => {
  try {
    showAlert(subActivityCheckboxesSelector, stopButtonSelector, executeCheckboxSelector, executeMultiactivityNoSubactivity);
  } catch (e) {
    errorManager(e);
  }
};

window.MultiactivityRegistration = { init };
